import {
  KINDS,
  NO_TIME_KINDS,
  buildConfigs,
  buildGetConfigByKind
} from '@/shared/level-play/activities/config'

import { question as initialQuestion } from './Initial/config'

/**
 * Registro de kinds do quiz.
 *
 * O catálogo em si é compartilhado (`shared/level-play/activities/config`), e é
 * lá que vivem os aliases `multiple_choice_question` e `text_question` que só o
 * backend do quiz emite.
 *
 * O que sobra aqui é de domínio: a tela `initial`, que precisa do registro do
 * quiz, e o `getConfig` com os caminhos de API.
 */

export { KINDS, NO_TIME_KINDS }

export const configs = buildConfigs([initialQuestion])
export const getConfigByKind = buildGetConfigByKind(configs)

export const icon = 'arrow-progress'
export const humanName = {
  singular: 'Nível',
  plural: 'Níveis'
}

export const getConfig = props => {
  const { digitalProductId } = props

  return {
    basePath: '/quizzes',
    apiBasePath: `/user/digital_products/${digitalProductId}/quizzes`,
    humanName,
    icon,
    pagination: {
      per_page: 999
    },
    configs,
    getConfigByKind,
    KINDS
  }
}
